//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tabbar from '../Tabbar'
import Scroll from '@/template/scroll'
import NewMessage from './new-message'
import FeedListItem from './list-item'
import wx from 'weixin-js-sdk'
import api from '@/api'
import config from '@/config'
import { wxShares } from '@/tools/util'
import {isIOS} from '@/tools/device'

export default {
  components: {
    Tabbar,
    Scroll,
    NewMessage,
    FeedListItem,
    wxShares
  },
  data: () => ({
    list: [],
    scrollVal: 0,
    addShow: true,
    time: null,
    wxShareData: {
      title: '',
      link: '',
      desc: '',
      imgUrl: ''
    },
    number: 0
  }),
  methods: {
    initData () {
      this.initFeed()
      this.getMessage()
      this.initWechat() // 初始化微信分享
      this.getAdvList()
    },
    getMessage () {
      this.axios.get(api.user.notifyNum)
      .then(response => {
        if (response.data.data) {
          this.number = response.data.data.comment_num + response.data.data.credit_num + response.data.data.notify_num
        }
      })
    },
    initFeed () {
      this.$refs.scrollComponent.init({
        api: api.feed.list,
        params: {
          type: this.type
        },
        response: 'data.data.list'
      })
    },
    getAdvList () {
      this.axios.get(api.adv.list, {
        params: {
          name: 'feed-list-index'
        }
      }).then(response => {
        if (response.data.code === 200) {
          console.log(1)
        }
      })
    },
    // 微信分享
    initWechat () {
      var url = window.sessionStorage.getItem('initUrl') || window.location.href
      var targetUrl = window.location.href
      if (isIOS()) {
        this.wxShareData.title = '房车圈'
        this.wxShareData.imgUrl = config.feedShareImage
        this.wxShareData.desc = '华人21世纪房车的达人都在这里了，21世纪房车，喜欢就一起来'
        this.wxShareData.link = targetUrl
        wxShares(this.wxShareData)
      } else {
        this.axios.post(api.rv.wxcode, {url: url})
        .then(response => {
          if (response.data.code === 200) {
            wx.config({
              debug: false,
              appId: response.data.data.appid,
              timestamp: response.data.data.timestamp,
              nonceStr: response.data.data.noncestr,
              signature: response.data.data.signature,
              jsApiList: [
                'onMenuShareAppMessage',
                'onMenuShareTimeline'
              ]
            })
            wx.ready(() => {
              // 发送给朋友
              wx.onMenuShareAppMessage({
                title: '房车圈',
                desc: '华人21世纪房车的达人都在这里了，21世纪房车，喜欢就一起来',
                link: targetUrl,
                imgUrl: config.feedShareImage,
                success: function (res) {
                },
                cancel: function (res) {
                }
              })
              // 朋友圈
              wx.onMenuShareTimeline({
                title: '房车圈 - 21世纪房车的达人都在这里了，21世纪房车，喜欢就一起来',
                link: targetUrl,
                imgUrl: config.feedShareImage,
                success: function (res) {
                },
                cancel: function (res) {
                }
              })
            })
            wx.error(function (res) {
            })
          }
        })
      }
    },
    doScroll () {
      clearTimeout(this.time)
      let scrollValue = document.getElementsByClassName('app-container')[0].scrollTop
      if (scrollValue > 0) {
        if (this.scrollVal < scrollValue) {
        // 向下
          this.addShow = false
        } else if (this.scrollVal > scrollValue) {
          // 向上
          this.addShow = true
        }
      } else {
        this.addShow = true
      }
      this.scrollVal = scrollValue
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.initData()
      } else {
        window.location.href = 'https://www.wanfangche.com'
      }
    })
    if (document.getElementsByClassName('app-container').length > 0) {
      document.getElementsByClassName('app-container')[0].addEventListener('scroll', this.doScroll)
    }
  },
  beforeDestroy () {
    if (document.getElementsByClassName('app-container').length > 0) {
      document.getElementsByClassName('app-container')[0].removeEventListener('scroll', this.doScroll)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/feed/home.vue